import "./scss/index.scss";
import { initFooterToggle } from "./js/components/footer-toggle.js";
import { initNavigation } from "./js/components/navigation.js";
import { initSwiper } from "./js/components/swiper.js";

// Załaduj na końcu, po GenerateBlocks
window.addEventListener("load", function () {
  initFooterToggle();
  initNavigation();
  initSwiper();
});

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector(
    ".post-type-archive-zamowienie .ct-dynamic-filter"
  );
  if (!el) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  el.addEventListener("mousedown", (e) => {
    isDown = true;
    el.classList.add("dragging");
    startX = e.pageX - el.offsetLeft;
    scrollLeft = el.scrollLeft;
  });
  el.addEventListener("mouseleave", () => (isDown = false));
  el.addEventListener("mouseup", () => (isDown = false));
  el.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = x - startX;
    el.scrollLeft = scrollLeft - walk;
  });
});
